import { useEffect, useState } from 'react';
import { PageModel } from '@adobe/aem-react-editable-components';
import { MarkerProps } from '../types/Tile';
import { getCookie } from '../../../utils/cookie';

export const useCacheId = (props: { model: MarkerProps }) => {
  const [cacheId, setCacheId] = useState('');

  useEffect(() => {
    const id = getCookie('traceId') ?? Date.now().toString();
    setCacheId(id);
  }, []);

  const model = { ...props.model, browserCacheId: cacheId } as MarkerProps & PageModel;

  return { ...props, model };
};
